<template>
  <div class="animated fadeIn">
    <vue-headful :title="`Lista Projektów`" />
    <b-col md="6">
      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <i class="fa fa-align-justify"></i> <strong>Projekty</strong>
          <b-button type="button" variant="btn btn-sm btn-primary" @click="editMode=!editMode">
            <i class="fa " :class="(!editMode) ? 'fa-square' : 'fa-check-square-o'"></i>&nbsp;Edycja
          </b-button>
          <small class="float-right">
            <b-button type="button" variant="btn btn-primary" @click="createProjectModal = true" title="Dodaj projekt">
              <i class="fa fa-plus"></i>&nbsp; Dodaj
            </b-button>
          </small>
        </div>
        <b-col md="12" v-if="loading">
          <div class="loading" >Loading...</div>
        </b-col>
        <div v-else-if="projects && projects.length > 0">
          <b-list-group v-bind:key="index" v-bind:item="project" v-for="(project, index) in projects">
            <b-list-group-item class="flex-column align-items-start">
              <div class="m-1 d-flex w-100 justify-content-between">
                <h5 class="cursor-pointer mb-1">{{ project.name }}
                </h5>
                <span v-if="editMode">
                  <i class="fa fa-pencil cursor-pointer" title="Kliknij, aby edytować" v-on:click="currentProject = project; changeNameModal = true"></i> |
                  <i class="fa fa-trash cursor-pointer" title="Kliknij, aby usunąć" v-on:click="remove(project)"></i>
                </span>
              </div>
            </b-list-group-item>
          </b-list-group>
        </div>
        <div v-else><i>Brak projektów</i></div>
      </b-card>
    </b-col>
    <b-modal size="md" hide-footer no-footer okTitle="Utwórz" cancelTitle="Anuluj" title="Nowy projekt" class="modal-primary" v-model="createProjectModal" @ok="createProject()">
      <div class="form-group">
        <b-form-group>
          <b-input-group @keyup.ctrl.enter="createProject()">
            <b-input-group-prepend>
              <b-input-group-text>Nazwa</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input name="Nazwa" v-model="newProjectName" type="text"></b-form-input>
          </b-input-group>
        </b-form-group>
        <button class="btn btn-primary float-right" @click="createProject()">Utwórz</button>
      </div>
    </b-modal>
    <b-modal size="sm" okTitle="Zapisz" cancelTitle="Anuluj" :title="currentProject.name" class="modal-primary" v-model="changeNameModal" @ok="changeName()">
      <div class="form-group">
        <b-form-group>
          <b-input-group @keyup.ctrl.enter="changeName()">
            <b-input-group-prepend>
              <b-input-group-text>Nazwa</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input name="Nazwa" v-model="currentProject.name" type="text"></b-form-input>
          </b-input-group>
        </b-form-group>
      </div>
    </b-modal>
  </div>
</template>

<script>
import leadsClient from '../../service/leadsClient'
import vueHeadful from 'vue-headful'

export default {
  name: 'projects-list',
  components: {
    vueHeadful
  },
  data () {
    return {
      loading: false,
      projects: null,
      editProjectModal: false,
      changeNameModal: false,
      editMode: false,
      createProjectModal: false,
      newProjectName: '',
      currentProject: {
        id: 0,
        name: ''
      },
      limit: '15',
      offset: '0'
    }
  },
  created () {
    this.getProjects()
  },
  methods: {
    async getProjects () {
      this.loading = true
      try {
        this.projects = await leadsClient.getProjects(999, 0)
      } finally {
        this.loading = false
      }
    },
    async createProject () {
      await leadsClient.createProject(this.newProjectName)
      this.createProjectModal = false
      await this.getProjects()
    },
    async changeName () {
      const project = this.currentProject
      await leadsClient.changeProjectName(project.id, project.name)
      this.changeProjectModal = false
      await this.getProjects()
    },
    async remove (project) {
      await this.$confirm('Czy na pewno chcesz usunąć projekt ' + project.name + '?', '', '', { confirmButtonText: 'Tak', cancelButtonText: 'Nie' })
      await leadsClient.disableProject(project.id)
      await this.getProjects()
    }
  }
}
</script>
